<template lang="pug">
.position-relative
  .invoice-popover(v-if="$route.query.invoice_id")
    PurchaseInvoicePage(:id="$route.query.invoice_id")
  div(v-else)
    UiStack(vertical)
      RestTable(
        namespace="vendor_invoices"
        :headers="headers"
        ref="vendorInvoicesTable"
        :fetch-handler="getData"
        :initial-filters="initialFilters"
        embed
      )
        template(#filters="{ filters, updateFilters }")
          UiStack
            UiStackItem(fill)
              UiFormGroup(
                :label="$t('companies.automation.bill_id')"
                label-for="company-name-input"
                label-cols="4"
              )
                UiInput#invoice-key-input(
                  :modelValue="filters.remote_key"
                  :allowClear="true"
                  @update:modelValue="updateFilters({ remote_key: $event })"
                )
            UiStackItem(fill)
              UiFormGroup(
                :label="$t('companies.automation.remote_key')"
                label-for="company-name-input"
                label-cols="4"
              )
                UiInput#invoice-key-input(
                  :modelValue="filters.bill_id"
                  :allowClear="true"
                  @update:modelValue="updateFilters({ bill_id: $event })"
                )
            UiStackItem(fill)
              UiFormGroup(
                :label="$t('companies.automation.start_date')"
                label-for="start-date-input"
                label-cols="5"
              )
                UiDatePicker#start-date-input(
                  :modelValue="new Date(filters.start_date)"
                  type="date"
                  @update:modelValue="updateFilters({ start_date: startOfDay($event) })"
                )
            UiStackItem(fill)
              UiFormGroup(
                :label="$t('companies.automation.end_date')"
                label-for="end-date-input"
                label-cols="5"
              )
                UiDatePicker#end-date-input(
                  :modelValue="new Date(filters.end_date)"
                  type="date"
                  @update:modelValue="updateFilters({ end_date: endOfDay($event) })"
                )
        template(#cell:remote_key="{ item }")
          RouterLink(
            :to="{ ...$route, query: { ...$route.query, invoice_id: item.id.toString() } }"
            label="item.name"
          ) {{ item.remote_key }}
</template>
<script>
import ApiCompanyVendors from "@/api/companyVendors.js";
import PurchaseInvoicePage from "@/views/PurchaseInvoice/show.vue";
import { addMonths } from "@/common/date_utils";
import { endOfDay, startOfDay } from "@bi-book/bibook-ui-kit";

export default {
  components: {
    PurchaseInvoicePage,
  },
  props: ["vendor_id"],

  data() {
    const startDate =
      typeof this.$route.query.purchaseInvoiceStartDate !== "undefined"
        ? new Date(this.$route.query.purchaseInvoiceStartDate)
        : addMonths(new Date(), -1);
    const endDate =
      typeof this.$route.query.purchaseInvoiceEndDate !== "undefined"
        ? new Date(this.$route.query.purchaseInvoiceEndDate)
        : new Date();
    return {
      items: [],
      initialFilters: {
        remote_key: "",
        bill_id: "",
        start_date: startDate.toISOString(),
        end_date: endDate.toISOString(),
        sort_order: "desc",
      },
      headers: [
        {
          key: "remote_key",
          label: "Bill ID",
          sortable: true,
        },
        {
          key: "bill_id",
          label: "Invoice Number",
          sortable: true,
        },
        {
          key: "date",
          label: "Invoice Date",
          sortable: true,
        },
        {
          key: "amount",
          label: "Invoice Amount",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        {
          key: "status_reason",
          label: "Status reason",
          sortable: true,
        },
        {
          key: "correct_accounts_percent",
          label: "Correct Accounts %",
          sortable: true,
        },
        {
          key: "correct_dimensions_percent",
          label: "Correct Dimensions %",
          sortable: true,
        },
      ],
    };
  },

  methods: {
    startOfDay: startOfDay,
    endOfDay: endOfDay,

    getData(params, config) {
      return ApiCompanyVendors.fetchPurchaseInvoices(
        this.$route.params.id,
        { vendor_id: this.vendor_id, ...params },
        config,
      ).then((resp) => {
        return {
          items: resp.data.purchase_invoices,
          meta: resp.data.meta,
        };
      });
    },
  },
};
</script>
